import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModUtils, ValidationUtils } from '../../../static/utils';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-input-custom',
  templateUrl: './input-custom.component.html',
  styleUrls: ['./input-custom.component.scss'],
})
export class InputCustomComponent implements OnInit {
  model:any=''
  constructor(
    private alertService: AlertService,
    private modalController: ModalController,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit() { }

  close() {
    this.modalController.dismiss();
  }

  async accept(){
    if(!this.model){
      this.alertService.presentToastError('Este campo no puede quedar vacío.');
      return;
    }
    if(!ValidationUtils.validatePhoneNumber(this.model)){
      this.alertService.presentToastError('Escribe un número válido.');
      return;
    }
    await this.modalController.dismiss(this.model);
  }

  constrainPhoneNumber(value: number) {
    this.cdRef.detectChanges();
    this.model = ModUtils.constrainNumToDigitLength(value, 10);
  }
}
